import * as actions from './actions'
/*const initialTractionsList = [
  {
    label: 'stock-vehicles-list-filters-traction-1',
    value: 1
  },
  {
    label: 'stock-vehicles-list-filters-traction-2',
    value: 2
  }
]

*/
const initialDoorsList = [
  {
    label: 'stock-vehicles-list-filters-door-1',
    value: 1
  },
  {
    label: 'stock-vehicles-list-filters-door-2',
    value: 2
  }
]

const initialPricesList = {
  min: 0,
  max: 50000,
  step: 5000
}

const initialMileagesList = {
  min: 0,
  max: 180000,
  step: 10000
}

const initialConfigurationsList = [
  {
    label: 'stock-vehicles-list-filters-type-1',
    value: 1
  },
  {
    label: 'stock-vehicles-list-filters-type-2',
    value: 2
  },
  {
    label: 'stock-vehicles-list-filters-type-3',
    value: 3
  }
]

const initialYearsList = {
  min: 1999,
  max: new Date().getFullYear(),
  step: 1
}

const initialCHsList = {
  min: 5,
  max: 20,
  step: 1
}

const initialCVsList = {
  min: 5,
  max: 20,
  step: 1
}

const initialSeatsList = [
  {
    label: 'stock-vehicles-list-filters-seat-1',
    value: 1
  },
  {
    label: 'stock-vehicles-list-filters-seat-2',
    value: 2
  },
  {
    label: 'stock-vehicles-list-filters-seat-3',
    value: 3
  },
  {
    label: 'stock-vehicles-list-filters-seat-4',
    value: 4
  }
]

const initialEcologiesList = [
  {
    label: 'stock-vehicles-list-filters-ecology-1',
    value: 1
  }
]

const initialColorsList = [
  {
    label: 'Blanc',
    value: '#fff'
  },
  {
    label: 'Gris',
    value: '#999'
  },
  {
    label: 'Noir',
    value: '#000'
  },
  {
    label: 'Bleu',
    value: '#215ce3'
  },
  {
    label: 'Jaune',
    value: '#f9f11d'
  },
  {
    label: 'Rouge',
    value: '#f81848'
  },
  {
    label: 'Vert',
    value: '#1ac466'
  }
]

export const INITIAL_STATE = {
  filtersList: {
    entities: null,
    pointOfSales: null,
    bodies: null,
    makes: null,
    models: null,
    configurations: initialConfigurationsList,
    fuels: null,
    transmissions: null,
    doors: initialDoorsList,
    mileages: initialMileagesList,
    prices: initialPricesList,
    years: initialYearsList,
    taxHorsepowers: initialCVsList,
    horsepowers: initialCHsList,
    seats: initialSeatsList,
    ecologies: initialEcologiesList,
    externalColorsReference: initialColorsList
    //tractionsList: null
  },
  filtersValues: {
    entities: [],
    pointOfSales: [],
    bodies: [],
    makes: [],
    models: [],
    configurations: [],
    fuels: [],
    transmissions: [],
    doors: [],
    mileageMin: null,
    mileageMax: null,
    priceMin: null,
    priceMax: null,
    putIntoServiceMin: null,
    putIntoServiceMax: null,
    taxHorsepowerMin: null,
    taxHorsepowerMax: null,
    horsepowerMin: null,
    horsepowerMax: null,
    seats: [],
    ecologies: [],
    externalColorsReference: []
  },
  vehiclesList: [],
  selectedVehicle: null,
  funding: null
}

export default function stockReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.SET_STOCK: {
      return action.stock
    }
    case actions.RESET_STOCK: {
      return INITIAL_STATE
    }
    default:
      return state
  }
}
